module.exports = __webpack_public_path__ + "img/masEditar.f213db71.svg";